// removed by extract-text-webpack-plugin
module.exports = {"loadMore":"ci_cj"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/LoadMore/styles.module.css
// module id = 1147
// module chunks = 27